export const getCounter = (state) => state.counter.count;